import React from 'react'
import '../../App.css'
import ProductPage from '../ProductPage';


export default function GetAQuote()
{
    return(
        <>
        <ProductPage />
        </>
    )  

}